import axios from "axios";
import dayjs from "dayjs";
import { resolveApiUrl } from "../assets/GlobalVariables";
import {
  attachAgentSessionToBody,
  buildAgentSessionRequestConfig,
  resolveAgentSessionIdSync,
} from "./agentApiSession";

const TOP_AGENTS_POST_PATH = "/api/agents/me/top-agents-of-month";

/**
 * @param {{ month?: string, limit?: number }} [opts]
 * @returns {Promise<object>}
 */
export async function getTopAgentsOfMonth(opts = {}) {
  const month = String(opts.month || dayjs().format("YYYY-MM")).trim();
  const limit = opts.limit ?? 5;

  const sid =
    resolveAgentSessionIdSync() ||
    (await buildAgentSessionRequestConfig({ timeout: 20000 })).sid;
  if (!sid) {
    throw new Error("agent_no_session");
  }

  const { headers, withCredentials, timeout } =
    await buildAgentSessionRequestConfig({ timeout: 20000 });

  const { data } = await axios.post(
    resolveApiUrl(TOP_AGENTS_POST_PATH),
    attachAgentSessionToBody({ sessionID: sid, month, limit }),
    { headers, withCredentials, timeout },
  );
  return data;
}
